export default __webpack_public_path__ + "static/media/box_open.de7299bc.svg";